/**
 * It multiples provided value by 4.
 */
const spacing = (amount: number) => amount * 4;

export { spacing };
